// Path: ./src/app/pages/CreateTabsPage/index.tsx
import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { PermissionComponentWrapper } from "../../components/PermissionComponentWrapper";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { SUPERADMIN } from "../../../utils/constant/stringConstant";
import BurstModeIcon from "@mui/icons-material/BurstMode";

function a11yProps(index: number) {
  return {
    id: `createFlyer-tab-${index}`,
    "aria-controls": `createFlyer-tabpanel-${index}`,
  };
}

interface Props {
  children?: React.ReactNode;
}
export default function CreateTabs({ children }: Props) {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const { state } = React.useContext(GoFlyerAdminContext);

  const location = useLocation();
  const { t } = useTranslation();

  const menuList = [
    {
      route: "/createflyer",
      name: t(messages.Create_FLyer()),
      Icon: HistoryEduIcon,
      group: "flyer",
      required: "view",
    },
    // {
    //   route: "/createdeal/view",
    //   name: t(messages.Create_Deals()),
    //   Icon: LocalOfferIcon,
    //   group: "deals",
    //   required: "view",
    // },
    {
      route: "/createcoupon",
      name: t(messages.Create_Coupon()),
      Icon: CreditScoreIcon,
      group: "coupon",
      required: "view",
    },
    {
      route: "/uploadflyer",
      name: t(messages.Upload_Flyer()),
      Icon: UploadFileIcon,
      group: "upload",
      required: "flyer",
    },
    {
      route: "/uploadmenu",
      name: t(messages.Upload_Menu()),
      Icon: RestaurantMenuIcon,
      group: "upload",
      required: "menu",
    },
    {
      route: "/storeuploadimage",
      name: t(messages.Store_Uploaded_Image()),
      Icon: BurstModeIcon,
      group: "flyer",
      required: "view",
    },
  ];

  /**
   * Navigates to the specified route.
   *
   * @param route - The route to navigate to.
   */
  const handleChange = (route: string) => {
    navigate(route);
  };

  React.useEffect(() => {
    if (location?.pathname) {
      const TabsList = [
        "flyer",
        // "deals",
        "coupon",
        "upload-flyer",
        "upload-menu",
        "store-upload-image",
      ];
      const groupNamesSet = new Set(
        state.user?.parsedRoles?.permissions.map((item) => item.groupName),
      );

      const filteredList =
        state.user?.parsedRoles?.name != SUPERADMIN
          ? TabsList.filter((value) => {
              const splitValue = value.split("-");
              const groupName = splitValue[0];
              if (splitValue.length > 1) {
                return state.user?.parsedRoles?.permissions?.find(
                  (val) =>
                    val.groupName === groupName &&
                    val.permissions.find(
                      (value) => value.allowed && value.name === splitValue[1],
                    ),
                );
              }
              return groupNamesSet.has(groupName);
            })
          : TabsList;

      if (location.pathname.startsWith("/createflyer")) {
        setValue(filteredList.indexOf("flyer"));
      }
      // if (location.pathname.startsWith("/createdeal")) {
      //   setValue(filteredList.indexOf("deals"));
      // }
      if (location.pathname.startsWith("/createcoupon")) {
        setValue(filteredList.indexOf("coupon"));
      }
      if (location.pathname.startsWith("/uploadflyer")) {
        setValue(filteredList.indexOf("upload-flyer"));
      }
      if (location.pathname.startsWith("/uploadmenu")) {
        setValue(filteredList.indexOf("upload-menu"));
      }
      if (location.pathname.startsWith("/storeuploadimage")) {
        setValue(filteredList.indexOf("store-upload-image"));
      }
    }
  }, [location?.pathname]);
  return (
    <Box
      sx={{ width: "100%", mt: { xs: 7, md: 8, lg: 8 } }}
      data-testid="createtabs-test-id"
    >
      <Box
        sx={{ borderBottom: 1, borderColor: "divider" }}
        style={{ backgroundColor: "#ededed" }}
      >
        <Tabs
          value={value}
          aria-label="create-tabs"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#ff8038",
            },
          }}
          style={{ marginLeft: 10 }}
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
        >
          {menuList?.map(({ Icon, name, group, required, route }, key) => {
            return (
              <PermissionComponentWrapper
                key={key}
                requiredPermission={[required]}
                requiredPermissionGroup={[group]}
                data-testid="createtabs-test-id"
              >
                <Tab
                  label={name}
                  {...a11yProps(key)}
                  onClick={() => {
                    handleChange(route);
                  }}
                  icon={
                    <Icon
                      style={{
                        fontSize: 23,
                        color: "#ff8038",
                        margin: 0,
                        marginRight: 3,
                        marginBottom: 3,
                      }}
                    ></Icon>
                  }
                  iconPosition="start"
                  sx={{
                    whiteSpace: "nowrap",
                    textTransform: "capitalize",
                    minHeight: 0,
                    paddingLeft: "2px",
                  }}
                />
              </PermissionComponentWrapper>
            );
          })}
        </Tabs>
      </Box>
      {children}
    </Box>
  );
}
